function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { ChevronRightIcon as ArrowIcon, CloseIcon } from '@domain-group/fe-co-icon';
import { Modal, RowButton, Button } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesTabbedPanel from '@domain-group/fe-co-allhomes-tabbed-panel';
import { medianPriceDataProps, medianStatProps } from './common-props';
import SuburbSummary from './components/suburb-summary';
import MedianSales from './components/median-sales';
import UnimprovedValue from './components/unimproved-value';
import MobileSuburbInfo from './components/mobile-suburb-info';
import * as styles from './allhomes-listing-suburb-stats-mobile.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesListingSuburbStatsMobile extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "openModal", () => {
      this.setState({
        isModalOpen: true
      });
      this.props.onSuburbInfoClick();
    });
    _defineProperty(this, "closeModal", () => {
      this.setState({
        isModalOpen: false
      });
    });
    _defineProperty(this, "updateSelectedTab", selectedTab => {
      if (selectedTab.id === 'median') {
        this.props.onMedianSalesTabClick();
      } else if (selectedTab.id === 'unimproved') {
        this.props.onUVClick();
      } else if (selectedTab.id === 'summary') {
        this.props.onSummaryTabClick();
      }
    });
    _defineProperty(this, "onViewMoreInfoClick", () => {
      this.props.onViewMoreInfoClick();
      window.location = this.props.suburbInfoLink;
    });
    this.state = {
      isModalOpen: false
    };
  }
  render() {
    var renderMedianSalesTab = _ref => {
      var isActive = _ref.isActive;
      return ___EmotionJSX("div", {
        css: styles.tabPanel
      }, ___EmotionJSX(MedianSales, _extends({
        key: isActive
      }, this.props, {
        height: 280
      })));
    };
    var renderUnimprovedValuesTab = _ref2 => {
      var isActive = _ref2.isActive;
      return ___EmotionJSX("div", {
        css: styles.tabPanel
      }, ___EmotionJSX(UnimprovedValue, {
        key: isActive,
        unimprovedValues: this.props.unimprovedValues,
        height: 280
      }));
    };
    var panels = [{
      tab: {
        id: 'summary',
        label: 'Summary'
      },
      content: ___EmotionJSX("div", {
        css: styles.tabPanel
      }, ___EmotionJSX(SuburbSummary, _extends({}, this.props, {
        layout: "no-title"
      })))
    }, {
      tab: {
        id: 'median',
        label: 'Median sales'
      },
      content: renderMedianSalesTab
    }, !isEmpty(this.props.unimprovedValues) && {
      tab: {
        id: 'unimproved',
        label: 'Unimproved value'
      },
      content: renderUnimprovedValuesTab
    }].filter(each => each);
    return ___EmotionJSX("div", null, ___EmotionJSX("div", null, (this.props.suburbInfoLink || this.props.hasSuburbInfo) && ___EmotionJSX(MobileSuburbInfo, {
      title: this.props.title,
      description: this.props.description,
      medianStatistics: this.props.medianStatistics,
      suburbName: this.props.suburbName,
      articles: this.props.articles,
      onClick: this.openModal,
      linkLabel: this.props.linkLabel,
      showSuburbInfoLink: this.props.showSuburbInfoLink,
      onViewMoreInfoClick: this.props.onViewMoreInfoClick,
      suburbInfoLink: this.props.suburbInfoLink
    })), ___EmotionJSX(Modal, {
      show: this.state.isModalOpen,
      title: this.props.mobileTitle,
      showGradient: false,
      closeButton: ___EmotionJSX(CloseIcon, {
        onClick: this.closeModal,
        css: styles.modalCloseIcon
      }),
      footer: this.props.showSuburbInfoLink && this.props.suburbInfoLink ? ___EmotionJSX("div", {
        css: styles.footer
      }, ___EmotionJSX(RowButton, {
        title: ___EmotionJSX("div", {
          css: styles.footerLink
        }, "View more suburb information"),
        collapse: true,
        leftIcon: null,
        rightIcon: ___EmotionJSX(ArrowIcon, {
          size: "small",
          css: styles.footerLinkIcon
        }),
        onClick: this.onViewMoreInfoClick,
        appearance: "ghost"
      })) : ___EmotionJSX("div", {
        css: styles.footerButton
      }, ___EmotionJSX(Button, {
        appearance: "ghost",
        onClick: this.closeModal
      }, "Close"))
    }, ___EmotionJSX("div", {
      css: styles.modalContents
    }, !this.props.suburbInfoLink && this.props.hasSuburbInfo && ___EmotionJSX("input", {
      css: styles.fakeTabbable
    }), this.props.medianPriceData && ___EmotionJSX(AllhomesTabbedPanel, {
      tabWrapper: ___EmotionJSX("div", {
        css: styles.tabbedPanelContainer
      }),
      panels: panels,
      onTabClick: this.updateSelectedTab,
      type: "css",
      underline: this.props.underline
    }), !this.props.medianPriceData && ___EmotionJSX(SuburbSummary, this.props))));
  }
}
AllhomesListingSuburbStatsMobile.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  suburbInfoLink: PropTypes.string,
  medianPriceData: PropTypes.shape(medianPriceDataProps),
  suburbName: PropTypes.string,
  unimprovedValues: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number,
    value: PropTypes.number,
    formatted: PropTypes.string
  })),
  articles: PropTypes.arrayOf(PropTypes.shape({})),
  disableAnimation: PropTypes.bool,
  onSuburbInfoClick: PropTypes.func,
  onMedianSalesTabClick: PropTypes.func,
  onUVClick: PropTypes.func,
  onSummaryTabClick: PropTypes.func,
  onViewMoreInfoClick: PropTypes.func,
  mobileTitle: PropTypes.string,
  hasSuburbInfo: PropTypes.bool,
  linkLabel: PropTypes.string,
  showSuburbInfoLink: PropTypes.bool,
  medianStatistics: PropTypes.shape(medianStatProps),
  underline: PropTypes.bool
};
AllhomesListingSuburbStatsMobile.defaultProps = {
  title: null,
  description: null,
  suburbInfoLink: null,
  medianPriceData: null,
  suburbName: '',
  unimprovedValues: [],
  disableAnimation: false,
  articles: [],
  onSuburbInfoClick: () => {},
  onMedianSalesTabClick: () => {},
  onUVClick: () => {},
  onSummaryTabClick: () => {},
  onViewMoreInfoClick: () => {},
  mobileTitle: 'Suburb and property insights',
  hasSuburbInfo: false,
  linkLabel: undefined,
  showSuburbInfoLink: true,
  medianStatistics: {},
  underline: false
};
export default AllhomesListingSuburbStatsMobile;